/**
 * Collect leaf option trade ids from a portfolio row (or nested strategy group).
 * Group rows use the first leg's id; real legs live under sub_order.
 */
export function collectLeafOptionIds(item) {
    if (!item) {
        return [];
    }
    const subs = Array.isArray(item.sub_order) ? item.sub_order : [];
    if (subs.length > 0) {
        return subs.flatMap(collectLeafOptionIds);
    }
    if (item.id == null || item.id === '') {
        return [];
    }
    return [item.id];
}

/**
 * Build DELETE /option query params so grouped rows remove every leg.
 */
export function buildOptionDeleteParams(item, userId) {
    const ids = collectLeafOptionIds(item);
    const params = {
        symbol: item.symbol,
        id: userId,
    };
    if (ids.length > 1) {
        params.option_ids = ids.join(',');
        if (item.strategy) {
            params.strategy = item.strategy;
        }
        return params;
    }
    if (ids.length === 1) {
        params.option_id = ids[0];
        return params;
    }
    if (item.id != null && item.id !== '') {
        params.option_id = item.id;
    }
    return params;
}
